<ng-container *ngIf="product$ | async as product">
  <ng-container *ngIf="mainImage$ | async as main">
    <cx-media *ngIf="(product.servicePart && product.images?.PRIMARY) || !product.servicePart; else spGearThumb"
      [container]="main" (click)="triggerZoom(true)" [alt]="product?.name" [title]="product?.name"></cx-media>
    <ng-template #spGearThumb>
      <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear" class="sp-gear-thumb">
    </ng-template>

    <ng-container *ngIf="(product.servicePart && product.images?.PRIMARY) || !product.servicePart">
      <gen-product-image-zoom-trigger [expandImage]="expandImage.value" [galleryIndex]="selectedIndex" (dialogClose)="triggerZoom(false)"></gen-product-image-zoom-trigger>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="thumbs$ | async as thumbs">
    <cx-carousel role="region" [attr.aria-label]="
        'carousel.carouselForProduct' | cxTranslate: { product: product.name }
      " tabindex="-1" *ngIf="thumbs.length" class="thumbs" [items]="thumbs" itemWidth="120px" [hideIndicators]="false"
      [template]="thumb"></cx-carousel>
  </ng-container>
</ng-container>

<ng-template #thumb let-item="item">
  <ng-container *ngIf="product$ | async as product">
    <cx-media [alt]="product?.name" [title]="product?.name" [container]="item.container" tabindex="0" (focus)="openImage(item.container)"
      [class.is-active]="isActive(item.container) | async" format="product">
    </cx-media>
  </ng-container>
</ng-template>